/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="91.15"
        height="95.58"
        viewBox="0 0 91.15 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="m79.66 51.14-23.4 22.75H6.73a6.65 6.65 0 1 0 0 13.29h52.32a6.58 6.58 0 0 0 4.68-1.86l25.44-24.76a6.6 6.6 0 0 0 .19-9.24l-.18-.19a6.84 6.84 0 0 0-9.52.01Zm7.76 1.79a4.1 4.1 0 0 1 0 5.86L62 83.5a4.08 4.08 0 0 1-2.93 1.15H6.73a4.15 4.15 0 1 1 0-8.29h50a1.27 1.27 0 0 0 .88-.36L81.4 52.93a4.34 4.34 0 0 1 5.85-.16Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M18.74 84.89a1.25 1.25 0 0 1 1.48 2l-.11.08-12.27 8a1.25 1.25 0 0 1-1.48-2l.11-.08ZM47.58 85.18a1.26 1.26 0 0 1 1.64-.32l.11.08 11.07 8.4a1.25 1.25 0 0 1-1.4 2.07l-.12-.08-11.06-8.4a1.26 1.26 0 0 1-.24-1.75Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M33.38 19.55a9.44 9.44 0 1 0 9.44 9.44 9.43 9.43 0 0 0-9.44-9.44Zm0 2.5a6.94 6.94 0 1 1-6.93 6.94 6.94 6.94 0 0 1 6.93-6.94ZM33.38 0a1.26 1.26 0 0 1 1.25 1.12v10.92a1.25 1.25 0 0 1-2.49.13V1.25A1.25 1.25 0 0 1 33.38 0ZM33.38 44.68a1.26 1.26 0 0 1 1.25 1.12v10.92a1.25 1.25 0 0 1-2.49.13V45.93a1.25 1.25 0 0 1 1.24-1.25ZM52.11 8.5A1.258 1.258 0 0 1 54 10.16l-.09.1-7.63 7.63a1.25 1.25 0 0 1-1.86-1.67l.09-.1ZM20.52 40.08a1.25 1.25 0 0 1 1.77 0 1.27 1.27 0 0 1 .09 1.67l-.09.1-7.64 7.65a1.243 1.243 0 0 1-1.85-1.66l.09-.1ZM61.12 27.74a1.25 1.25 0 0 1 .13 2.49H50.33a1.252 1.252 0 0 1-.13-2.5h10.92ZM16.44 27.74a1.25 1.25 0 0 1 .13 2.49H5.65a1.252 1.252 0 0 1-.13-2.5h10.92ZM44.48 40.08a1.27 1.27 0 0 1 1.67-.09l.1.09 7.63 7.64a1.25 1.25 0 0 1-1.67 1.85l-.1-.09-7.63-7.63a1.25 1.25 0 0 1 0-1.77ZM12.89 8.5a1.23 1.23 0 0 1 1.66-.09l.1.09 7.64 7.63a1.25 1.25 0 0 1-1.67 1.86l-.1-.09-7.63-7.63a1.25 1.25 0 0 1 0-1.77Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'BeachChairWithSunIcon';

export default Icon;
